import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

/*--------------------------------------------STYLES--------------------------------------------*/

//color palette
export const COLORS = {
    gold: "#c8b668",
    goldLight: '#d5c478',
    goldDark: "#8e7a2c",
    goldDarker: "#6e5f20",
    black: '#333333',
    offWhite: '#f1f1f1',
    red: "#E53935",
    // Phase I blues — two candidates to test. The pages refactored to light mode read from
    // COLORS.blue as the unified accent. After deciding, set COLORS.blue to the chosen value
    // and the whole app updates in one place.
    blue: "#2563EB",     // Candidate A — Royal (vivid, high contrast with gold)
    blueAlt: "#1E40AF",  // Candidate B — Navy (deeper, more traditional)
    blueSoft: "rgba(37, 99, 235, 0.08)" // soft tint for selected rows (matches Candidate A)
};

export const header = {
    backgroundColor: COLORS.black,
    color: COLORS.offWhite,
    padding: "12px 16px"
}

export const footer = {
    backgroundColor: COLORS.black,
    color: COLORS.offWhite,
    padding: "12px 16px"
}

export const stickyThStyle = {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    backgroundColor: "white"
}

export const adminStickyThStyle = {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    backgroundColor: "white",
    borderRight: "1px solid #dee2e6"
}

//make links gold
export const goldLinkBase = {
    color: COLORS.gold,
    fontSize: 12,
    padding: 0,
    textDecoration: "none",
    transition: "color .15s ease"
};

export const addUnderline = {
    textDecoration: 'underline'
};

export const removeUnderline = {
    textDecoration: 'none'
};

//push down effect on buttons using a shadow
export const boxshadowHover = {
    boxShadow: "0 1px 3px rgba(0,0,0,.35)",
    transform: "translateY(1px)",
}

//remove boxshadowHover effect, ex: when a mouse moves off the button
export const boxshadowUnHover = baseStyle => ({
    ...baseStyle,
    boxShadow: "0 3px 6px rgba(0, 0, 0, .45)",
    transform: "translateY(-1px)",
})

// Hover/un-hover use inset box-shadow instead of borders so the row's box
// model stays the same in both states. The previous border-based approach
// changed the row's height by ~3px between hover/un-hover, which caused
// the table to "shake" as the cursor crossed rows on the way to a header
// dropdown. Inset shadows render over the cell without taking any layout
// space, so height is now constant.
export const tableRowHover = {
    boxShadow: `inset 0 1px 0 ${COLORS.gold}, inset 0 -2px 0 ${COLORS.gold}`,
    border: "none",
    borderBottom: "1px solid #dee2e6"
}


export const tableRowUnHover = {
    boxShadow: "none",
    border: "none",
    borderBottom: "1px solid #dee2e6"
}

export const filterActiveIndicator = {
    display: 'block',
    width: '100%',
    height: '3px',
    background: COLORS.gold,
    borderRadius: '2px',
    marginTop: '2px',
};

/*-----------------------------BUTTONS-----------------------------*/

//make buttons gold
export const btnGold = {
    backgroundColor: COLORS.gold,
    borderColor: COLORS.gold,
    color: COLORS.black,
    fontWeight: 600,
    boxShadow: "0 3px 6px rgba(0, 0, 0, .45)",
    transition: "box-shadow .12s ease, transform .12s ease"
};

//make buttons gold
export const btnRed = {
    backgroundColor: COLORS.red,
    borderColor: COLORS.red,
    color: COLORS.black,
    fontWeight: 600,
    boxShadow: "0 3px 6px rgba(0, 0, 0, .45)",
    transition: "box-shadow .12s ease, transform .12s ease"
};

//lighten color when hovering on a button
export const btnGoldHover = {
    backgroundColor: COLORS.goldLight
};

export const statusColors = {
    Processing: "#66B2FF",
    Available: "#73D68E",
    Downloaded: "#5BCDD7",
    Exception: "#FFDB66",
    Rejected: "#E87979",
    //"Mapping Needed" — doc-conversion-only status (StatementItemStatus = 7).
    //Uses the same warm gold family as Exception so it reads as "attention
    //needed" but is distinct from a hard exception. The two-word label uses
    //a key with a space to match the statusString from the backend DTO.
    "Mapping Needed": "#F2B441",
    //"Duplicate" — doc-conversion-only status (StatementItemStatus = 8). Neutral grey:
    //the row is informational, not an error and not actionable.
    Duplicate: "#B9BFC7"
}

export const darkStatusColors = {
    Processing: "#003C9D",
    Available: "#1B602D",
    Downloaded: "#0B6775",
    Exception: "#8F7300",
    Rejected: "#921E1E",
    "Mapping Needed": "#7A5A12",
    Duplicate: "#4A5058"
}

//style for button to activate showing more or less filters
export const showAdvancedBtn = {
    color: COLORS.gold,
    fontSize: 15,
    fontWeight: "bold",
    padding: 0,
    textDecoration: "none",
    transition: "color .15s ease"
}

export const searchBtn = {
    ...btnGold,
    marginRight: 3,
}

export const uploadBtn = {
    ...btnGold,
    marginRight: 20,
}

export const resetFiltersBtn = {
    ...btnGold,
    marginRight: 3,
}

export const resetBtnGrey = {
    backgroundColor: "lightGray",
    borderColor: "lightGray",
    color: COLORS.black,
    fontWeight: 600,
    boxShadow: "0 3px 6px rgba(0, 0, 0, .45)",
    transition: "box-shadow .12s ease, transform .12s ease"
};

export const sourceDataBtn = {
    backgroundColor: COLORS.gold,
    border: "1px solid #000",
    color: "black",
    fontFamily: '"Roboto Mono", monospace',
    fontSize: "10px",
    fontWeight: 600,
    letterSpacing: 0.2,
    minWidth: 40,
    maxWidth: 60,
    boxShadow: "0 3px 6px rgba(0, 0, 0, .45)",
    transition: "box-shadow .12s ease, transform .12s ease"
}

export const backBtn = {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "14px",
        cursor: "pointer",
        border: "1px solid #e5e7eb",
        padding: "8px 12px",
        borderRadius: "8px",
        background: "#f9fafb",
        color: "black"
};

/*-----------------------------End of Buttons-----------------------------*/

//style for input form labels | ex: DOC Id
export const formLabel = {
    backgroundColor: 'transparent',
    borderColor: "#333",
    color: COLORS.offWhite,
    fontWeight: "bold",
    marginBottom: 0
};

export const columnTitle = {
    textAlign: 'center',
    fontSize: "0.9rem",
    fontWeight: 'bold',

    textTransform: "uppercase",
    paddingBottom: 4,
}

export const columnSortLink = {
    ...columnTitle,
    padding: '0px'
}

//highlight input boxes gold when clicked on
export const goldInputFocus = {
    outline: "none",
    border: "none",
    boxShadow: "0 0 0 0.15rem rgba(200,182,104)",
}

export const statusLabel = {
    borderRadius: 10,
    padding: "2px 8px",
    display: "inline-block",
    minWidth: "11ch",
    textAlign: "center"
}

/*-----------------------------ICONS-----------------------------*/

//box that can go around items / icons | ex: faPlus
export const frame = {
    width: 32,
    height: 32,
    border: "1px solid #000",
    borderRadius: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: COLORS.gold,
    boxShadow: "0 3px 6px rgba(0, 0, 0, .45)",
    transition: "box-shadow .12s ease, transform .12s ease",
    color: "black"
};

//gold faPlus icon style
export const goldFaPlus = icon =>
    icon === faPlus
        ? {
            ...frame,
            display: "inline-flex",
            width: 12,
            height: 12
        }
        : undefined;

export const faIconStyle = icon =>
    icon === faArrowDown
        ? {
            //backgroundColor: COLORS.gold,
            color: "black",
            width: 10,
            height: 10,
            marginRight: 1,
            borderBottom: "1px solid #000",
            background: "transparent",
            backgroundColor: "transparent",
            outline: "none",
            boxShadow: "none"
        }
        : {
            background: "transparent",
            backgroundColor: "transparent",
            outline: "none",
            boxShadow: "none"
          }

/*-----------------------------End of Icons-----------------------------*/

//input box style
export const inputSm = {
    fontSize: "12px"
};

//style for page component
export const paginationStyle = {
    backgroundColor: "transparent",
    color: COLORS.gold,
    cursor: "pointer",
    transition: "all .15s ease"
}

export const activePaginationStyle = {
    backgroundColor: COLORS.gold,
    border: "none",
    color: "#1a1a1a",
    outline: "none",
    boxShadow: "none",
    cursor: "pointer",
    transition: "all .15s ease"
}

/*-----------------------------DROP DOWNS-----------------------------*/

export const dropDownToggle = {
    ...inputSm,
    width: "100%",
    textAlign: "left",
    padding: "4px 17px 4px 4px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
}

export const dropDownInput = {
    ...inputSm,
    width: "90%",
    marginBottom: "6px",
    marginLeft: 4
}

export const dropDownMenu = {
    maxHeight: 200,
    overflowY: "auto",
    '--bs-dropdown-link-active-bg': COLORS.gold,
    '--bs-dropdown-link-active-color': '#fff'
}

/*-----------------------------LIGHT MODE (Phase I)-----------------------------*/
// Shared tokens for pages refactored out of dark mode. Per the Phase I style doc:
//  - White backgrounds with dark text (add shadows if they need to pop)
//  - Blue is an accent, never a backdrop
//  - Charcoal (COLORS.black) for any dark band like a table header

export const LIGHT = {
    cardBg: '#ffffff',
    cardBorder: '1px solid #e5e7eb',
    cardShadow: '0 4px 14px rgba(0,0,0,.12)',
    cardShadowHover: '0 8px 24px rgba(0,0,0,.18)',
    headerBg: COLORS.black,
    headerText: COLORS.offWhite,
    footerBg: '#f9fafb',
    primaryText: '#1f2937',
    mutedText: '#6b7280',
    rowHover: '#f3f4f6',
    rowSelectedBg: COLORS.blueSoft,
    rowSelectedText: COLORS.blue,
    rowDefaultText: '#374151',
    dangerText: '#b91c1c'
};

export const lightCard = {
    background: LIGHT.cardBg,
    border: LIGHT.cardBorder,
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: LIGHT.cardShadow
};

export const lightCardHeader = {
    background: LIGHT.headerBg,
    color: LIGHT.headerText,
    borderBottom: '1px solid rgba(0,0,0,.08)',
    padding: '12px 16px'
};

export const lightCardFooter = {
    background: LIGHT.footerBg,
    borderTop: '1px solid #e5e7eb',
    color: LIGHT.primaryText,
    padding: '12px 16px'
};

export const lightTitle = {
    fontSize: '1.75rem',
    fontWeight: '700',
    color: COLORS.black,
    textAlign: 'center'
};

/*--------------------------------------------END OF STYLES--------------------------------------------*/